// @flow
import { FormattedMessage } from 'react-intl';
import { getSavedSearchesUrl } from '../../utils/urls';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './DeletedItemMessage.module.scss';

type Props = $ReadOnly<{|
    itemTitle: string,
|}>;

const DeletedItemMessage = (props: Props) => {
    const { itemTitle } = props;
    return (
        <div className={styles['deleted-item-message-container']}>
            <div>
                <span className={styles['item-title']}>{itemTitle}</span>
                <FormattedMessage id="deleted_item_1" />
                <br />
                <Link to={getSavedSearchesUrl()}>
                    <FormattedMessage id="deleted_item_2" />
                </Link>
                <FormattedMessage id="deleted_item_3" />
            </div>
        </div>
    );
};

export default React.memo<Props>(DeletedItemMessage);
